import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import type { ISeedFailedOrdersContextValue } from './types';

export default createContext<ISeedFailedOrdersContextValue>({
  state: initialState,
  actions: initialActionsState,
});
